import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import React, { Component } from 'react';
import { SVGIcon } from '@instructure/ui-svg-images';

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M1581.176 1750.588c0 31.06-25.411 56.47-56.47 56.47H395.294c-31.059 0-56.47-25.41-56.47-56.47V564.706H225.882v1185.882c0 93.403 76.01 169.412 169.412 169.412h1129.412c93.402 0 169.412-76.01 169.412-169.412V564.706h-112.942v1185.882zm-903.529-169.412h112.941V677.647h-112.94v903.53zm451.765 0h112.94V677.647h-112.94v903.53zm211.211-1242.352L1217.065 0H694.6L571.268 338.824H.01v112.94h1920v-112.94h-579.388zm-649.299 0l82.334-225.883h364.462l82.334 225.883h-529.13z",
  fillRule: "evenodd",
  stroke: "none",
  strokeWidth: "1"
});

var IconTrashLine = /*#__PURE__*/function (_Component) {
  _inherits(IconTrashLine, _Component);

  var _super = _createSuper(IconTrashLine);

  function IconTrashLine() {
    _classCallCheck(this, IconTrashLine);

    return _super.apply(this, arguments);
  }

  _createClass(IconTrashLine, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(SVGIcon, Object.assign({}, this.props, {
        name: "IconTrash",
        viewBox: "0 0 1920 1920"
      }), _ref);
    }
  }]);

  IconTrashLine.displayName = "IconTrashLine";
  return IconTrashLine;
}(Component);

IconTrashLine.glyphName = 'trash';
IconTrashLine.variant = 'Line';
IconTrashLine.propTypes = _objectSpread({}, SVGIcon.propTypes);
export default IconTrashLine;
export { IconTrashLine };